import { mutatorAction } from 'satcheljs';
import getWeatherOption from '../store/store';
export default mutatorAction('discardWeatherOption', function discardWeatherOption() {
    var optionState = getWeatherOption();
    optionState.weatherEnabled = null;
    optionState.weatherUnit = null;
});
//# sourceMappingURL=discardWeatherOption.js.map